// A line-clamped element's scrollHeight can exceed its offsetHeight by up to
// 9px even when nothing is clamped away.
const LINE_CLAMP_SCROLL_HEIGHT_TOLERANCE = 9;

export const isTextTruncated = (
  { offsetWidth, offsetHeight, scrollWidth, scrollHeight }: HTMLElement,
  lineClamp?: number
): boolean =>
  offsetWidth < scrollWidth ||
  (Boolean(lineClamp) &&
    scrollHeight - offsetHeight > LINE_CLAMP_SCROLL_HEIGHT_TOLERANCE);
